import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveActivityGalleryPayload } from "../types/activityGalleryType";

export const getActivityGalleryList = createAsyncThunk("/activityGallery/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/activitygallery?${query.toString()}`)).data;
  return response;
});

export const saveActivityGallery = createAsyncThunk("/activityGallery/save", async (payload: SaveActivityGalleryPayload) => {
  const response = (await api.post("/activitygallery/action", payload)).data;
  return response;
});

export const deleteActivityGallery = createAsyncThunk("/activityGallery/delete", async (id: number) => {
  const response = (await api.get(`/activitygallery/delete/${id}`)).data;
  return response;
});
